import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import Toggle from 'react-toggle';
import { PulseLoader } from 'react-spinners';
import { FaExclamationCircle } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { storeAvailable } from '../../../../queries';

import {
  Padding,
  Content,
  Footer,
  ToggleContainer,
  AlertContainer,
  Button,
} from './styles';

class StoreAvailability extends Component {
  state = {
    loading: false,
    availability: undefined,
    open: undefined,
  }

  openStoreAvailabilityModal = () => {
    this.setState({
      availability: this.props.store.status.available,
      open: this.props.store.status.open,
    });
  }

  handleSubmit = async () => {
    this.setState({ loading: true });

    this.props
      .storeAvailable({
        variables: {
          storeId: this.props.store.id,
          available: this.state.availability,
        },
      })
      .then(async () => {
        this.setState({ loading: false });

        this.props.saveStore({
          status: {
            ...this.props.store.status,
            available: this.state.availability,
          },
        });

        this.props.close();

        if (this.props.drawer) this.props.drawerHandler();
      });
  }

  handleToggleButton = () => {
    this.setState(state => ({ availability: !state.availability }));
  }

  render() {
    const { loading, availability } = this.state;
    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.categoryModal = ref; }}
        styles={{
          modal: { width: '460px' },
        }}
      >
        <Content>
          <Padding>
            <h2>Alterar disponibilidade</h2>
          </Padding>
          <Footer>
            <ToggleContainer>
              <Toggle
                defaultChecked={!availability}
                icons={false}
                onChange={this.handleToggleButton}
              />
              <span>Indisponível</span>
            </ToggleContainer>
            <p>
              {'Se o botão estiver habilitado a loja será fechada por tempo indeterminado e não poderá mais receber pedidos.'}
            </p>
          </Footer>
          {!this.state.open && availability && (
            <AlertContainer>
              <FaExclamationCircle className="fa fa-exclamation-circle" />
              <p>O horário de entrega da loja se encerrou. Portanto, não receberá mais pedidos.</p>
            </AlertContainer>
          )}
          <Padding>
            <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                'Salvar'
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                />
              )}
            </Button>
          </Padding>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  graphql(storeAvailable, { name: 'storeAvailable', withRef: true }),
)(StoreAvailability);
